import ProgressBar from 'components/ProgressBar';
import Spacer from 'components/Spacer';
import Timeline from 'components/Timeline';
import { STEPS, StepPercentage } from 'constants/steps';
import React from 'react';

type Props = {
  stepCounter: number;
  stepPercentage: STEPS;
  timelineStep: number;
  lastPage?: boolean;
};

export default function InfoBar({
  stepCounter,
  timelineStep,
  stepPercentage,
  lastPage = false
}: Props) {
  return (
    <div>
      <div className="flex flex-col items-center">
        <p className="font-circular text-4xl text-[#353535]">
          {stepCounter} more steps to go...
        </p>

        <Spacer height={30} />
        <Timeline stepCount={timelineStep} isLastPage={lastPage} />
        <Spacer height={20} />
        <ProgressBar percentage={StepPercentage[stepPercentage]} />
      </div>
    </div>
  );
}
